export const getCurrentPath = () => {
  const path = window.location.pathname;
  return path;
};